import { render, staticRenderFns } from "./Dosis.vue?vue&type=template&id=1aa08e8d&scoped=true"
import script from "./Dosis.vue?vue&type=script&lang=js"
export * from "./Dosis.vue?vue&type=script&lang=js"
import style0 from "./Dosis.vue?vue&type=style&index=0&id=1aa08e8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa08e8d",
  null
  
)

/* custom blocks */
import block0 from "./Dosis.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports